import { styled } from '@mui/material';
import { MobilePaddingLessContentWrapper } from '../../../styles/shared';

export const StyledContentWrapper = styled(MobilePaddingLessContentWrapper)(
  ({ theme }) => ({
    [theme.breakpointsMediaQuery.up('md')]: {
      padding: `0 ${theme.spacings.unit(26)}`,
    },
  })
);

export const RepeaterWrapper = styled('div')(({ theme }) => ({
  margin: `${theme.spacings.unit(12)} 0 ${theme.spacings.unit(13)}`,
}));

export const MainTitle = styled('h2')(({ theme }) => ({
  fontSize: theme.fonts.utility.size(32 / 2),
  fontWeight: 600,
  marginTop: 0,
  marginBottom: theme.spacings.unit(9),
  textAlign: 'center',
  [theme.breakpointsMediaQuery.up('sm')]: {
    textAlign: 'center',
  },
}));
